import { TextField, MenuItem, TextFieldProps } from '@mui/material';
import { FormikProps } from 'formik';

interface SelectOption {
  value: string | number | boolean;
  label: string;
}

interface SelectFieldProps extends Omit<TextFieldProps, 'name' | 'select'> {
  name: string;
  formik: FormikProps<any>;
  options: SelectOption[];
}

export default function SelectField({ formik, name, options, ...props }: SelectFieldProps) {
  const error = formik.touched[name] && Boolean(formik.errors[name]);
  const helperText = formik.touched[name] && formik.errors[name];

  return (
    <TextField
      fullWidth
      select
      size="small"
      shrink
      {...props}
      name={name}
      value={formik.values[name]}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={error}
      helperText={helperText as string}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '10px',
          '&:hover fieldset': {
            borderColor: '#e53935',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#e53935',
          },
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#e53935',
        },
        mt: 0,
        mb: 0,
        ...props.sx,
      }}
    >
      {options.map((option) => (
        <MenuItem key={String(option.value)} value={String(option.value)}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
